import axios from 'axios';
import { HttpResponse } from './http-response';

export class HttpClient {
  static responseType = null;

  /**
   * Ge instance of axios client.
   *
   * @returns {AxiosStatic}
   */
  static instance(useThemeApi) {
    const instance = axios.create({
      baseURL: `${process.env.VUE_APP_API_URL || ''}/api/${useThemeApi ? 'theme' : process.env.VUE_APP_API_VERSION}`,
    });
    instance.interceptors.request.use(requestConfig => this.alterRequest(requestConfig));
    return instance;
  }

  /**
   *
   * @param {AxiosRequestConfig} requestConfig
   * @returns {AxiosRequestConfig}
   */
  static alterRequest(requestConfig) {
    requestConfig.headers = { ...this.defaultHeaders(), ...requestConfig.headers };
    requestConfig.responseType = this.responseType || requestConfig.responseType;
    return requestConfig;
  }

  /**
   * Default headers.
   *
   * @returns {{}}
   */
  static defaultHeaders() {
    return {};
  }

  /**
   * Default headers.
   *
   * @param {AxiosResponse<T>} response
   * @param {object} requestConfig
   *
   * @returns {HttpResponse}
   */
  static transformResponse(response, requestConfig) {
    return new HttpResponse(response, requestConfig);
  }

  /**
   * Send GET request.
   *
   * @param {string} url
   * @param {object=} requestConfig
   * @returns {Promise<HttpResponse>}
   */
  static get(url, requestConfig = {}) {
    return this.instance(requestConfig.useThemeApi)
      .get(url, requestConfig)
      .then(response => this.transformResponse(response, requestConfig))
      .catch(response => {
        throw this.transformResponse(response.response, requestConfig);
      });
  }

  /**
   * Send POST request.
   *
   * @param {string} url
   * @param {object=} data
   * @param {object=} requestConfig
   * @returns {Promise<HttpResponse>}
   */
  static post(url, data = {}, requestConfig = {}) {
    return this.instance(requestConfig.useThemeApi)
      .post(url, data, requestConfig)
      .then(response => this.transformResponse(response, requestConfig))
      .catch(response => {
        throw this.transformResponse(response.response, requestConfig);
      });
  }

  /**
   * Send PUT request.
   *
   * @param {string} url
   * @param {object=} data
   * @param {object=} requestConfig
   * @returns {Promise<HttpResponse>}
   */
  static put(url, data = {}, requestConfig = {}) {
    return this.instance()
      .put(url, data, requestConfig)
      .then(response => this.transformResponse(response, requestConfig))
      .catch(response => {
        throw this.transformResponse(response.response, requestConfig);
      });
  }

  /**
   * Send PATCH request.
   *
   * @param {string} url
   * @param {object=} data
   * @param {object=} requestConfig
   * @returns {Promise<HttpResponse>}
   */
  static patch(url, data = {}, requestConfig = {}) {
    return this.instance()
      .patch(url, data, requestConfig)
      .then(response => this.transformResponse(response, requestConfig))
      .catch(response => {
        throw this.transformResponse(response.response, requestConfig);
      });
  }

  /**
   * Send DELETE request.
   *
   * @param {string} url
   * @param {object=} requestConfig
   * @returns {Promise<HttpResponse>}
   */
  static delete(url, requestConfig = {}) {
    return this.instance()
      .delete(url, requestConfig)
      .then(response => this.transformResponse(response, requestConfig))
      .catch(response => {
        throw this.transformResponse(response.response, requestConfig);
      });
  }
}
